import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgxSpinnerModule } from "ngx-spinner";
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import {NgbPaginationModule, NgbAlertModule} from '@ng-bootstrap/ng-bootstrap';
import { HashLocationStrategy, LocationStrategy ,PathLocationStrategy} from '@angular/common';
import { MatSortModule } from '@angular/material/sort';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthComponent } from './auth/auth.component';
import { LoginComponent } from './auth/login/login.component';
import { AdminLoginComponent } from './admin/admin-login/admin-login.component';
import { LayoutComponent } from './layout/layout.component';
import { AssignedComponent } from './layout/assigned/assigned.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AssignedDetailsComponent } from './layout/assigned-details/assigned-details.component';

import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTableModule} from '@angular/material/table';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatRadioModule} from '@angular/material/radio';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms'
 
import { CompletedComponent } from './layout/completed/completed.component';
import { CompletedDetailsComponent } from './layout/completed-details/completed-details.component';
import { ViewerComponent } from './layout/viewer/viewer.component';
import { ViewerQuestionComponent } from './layout/viewer-question/viewer-question.component';
import { SubmodulePassedComponent } from './layout/submodule-passed/submodule-passed.component';
import { ModulePassedComponent } from './layout/module-passed/module-passed.component';
import { ModuleFailedComponent } from './layout/module-failed/module-failed.component';
import { ContactAdminComponent } from './layout/contact-admin/contact-admin.component';
import { AdminComponent } from './admin/admin.component';
import { UserComponent } from './admin/user/user.component';
import { UserEditComponent } from './admin/user-edit/user-edit.component';
import { UserCreateComponent } from './admin/user-create/user-create.component';
import { HeaderAdminComponent } from './admin/header-admin/header-admin.component';
import { FooterAdminComponent } from './admin/footer-admin/footer-admin.component';
import { ViewerDetailsComponent } from './layout/viewer-details/viewer-details.component';
import { UserSuccessfullyComponent } from './admin/user-successfully/user-successfully.component';
import { ViewCoursesComponent } from './admin/view-courses/view-courses.component';
import { AssignCoursesComponent } from './admin/assign-courses/assign-courses.component';
import { UserDeactiveComponent } from './admin/user-deactive/user-deactive.component';
import { OrganisationComponent } from './admin/organisation/organisation.component';
import { OrganisationCreateComponent } from './admin/organisation-create/organisation-create.component';
import { CourseComponent } from './admin/course/course.component';
import { CourseDetailsComponent } from './admin/course-details/course-details.component';
import { OrganisationCourseComponent } from './admin/organisation-course/organisation-course.component';
import { CourseViewUserComponent } from './admin/course-view-user/course-view-user.component';
import { CourseViewCourseComponent } from './admin/course-view-course/course-view-course.component';
import { CourseCreateComponent } from './admin/course-create/course-create.component';
import { AssignedResumeComponent } from './layout/assigned-resume/assigned-resume.component';
import { CourseAddModulesComponent } from './admin/course-add-modules/course-add-modules.component';
import { CourseAddReviewComponent } from './admin/course-add-review/course-add-review.component';
import { CourseAddAssignUserComponent } from './admin/course-add-assign-user/course-add-assign-user.component';
import { CourseContentCapsuleComponent } from './admin/course-content-capsule/course-content-capsule.component';
import { ViewerQuestionLastComponent } from './layout/viewer-question-last/viewer-question-last.component';
import { AssignedDetailsMoudleComponent } from './layout/assigned-details-moudle/assigned-details-moudle.component';
import { CoursePublishComponent } from './admin/course-publish/course-publish.component';
import { AddModuleAssessmentComponent } from './admin/add-module-assessment/add-module-assessment.component';
import { AssignedAttemptComponent } from './layout/assigned-attempt/assigned-attempt.component';
import { AssignedDetailsResumeComponent } from './layout/assigned-details-resume/assigned-details-resume.component';
import { AssignedContactAdministratorComponent } from './layout/assigned-contact-administrator/assigned-contact-administrator.component';
import { AssignedResetRequestComponent } from './layout/assigned-reset-request/assigned-reset-request.component';
import { ChangepasswordComponent } from './layout/changepassword/changepassword.component';
import { AuthoringCreateComponent } from './admin/authoring-create/authoring-create.component';
import { AuthoringViewComponent } from './admin/authoring-view/authoring-view.component';
import { AuthoringAssessmentViewComponent } from './admin/authoring-assessment-view/authoring-assessment-view.component';
import { AuthoringListComponent } from './admin/authoring-list/authoring-list.component';
import { AuthoringActivatedCourseComponent } from './admin/authoring-activated-course/authoring-activated-course.component';
import { AuthoringDeactivatedCourseComponent } from './admin/authoring-deactivated-course/authoring-deactivated-course.component';
import { AuthoringViewContentComponent } from './admin/authoring-view-content/authoring-view-content.component';
import { ResetComponent } from './admin/reset/reset.component';
import { ResetRequestComponent } from './admin/reset-request/reset-request.component';
import { ContentAuthoringService } from "./services/content-authoring.service";
import { HttpClientModule } from '@angular/common/http';
import { CKEditorModule } from 'ckeditor4-angular';
import { ContentAuthSuccessComponent } from './admin/content-auth-success/content-auth-success.component';
import { ToastrModule } from 'ngx-toastr';
import { AddAuthoringAssessmentComponent } from './admin/add-authoring-assessment/add-authoring-assessment.component';
import { CourseAssignAfterPublishComponent } from './admin/course-assign-after-publish/course-assign-after-publish.component';
import { CoursesAssignUsersComponent } from './admin/courses-assign-users/courses-assign-users.component';
import { ForgetPasswordComponent } from './auth/forget-password/forget-password.component';
import { MatStepperModule } from '@angular/material/stepper';
import { CreatePasswordComponent } from './auth/create-password/create-password.component';
import { ContactUsComponent } from './auth/contact-us/contact-us.component';
import { CountdownModule } from 'ngx-countdown';
import { MatMenuModule } from '@angular/material/menu';
import {CdkStepperModule} from '@angular/cdk/stepper';
import { OrganizationSuccessfullyComponent } from './admin/organization-successfully/organization-successfully.component';
import { ViewCapsuleComponent } from './admin/view-capsule/view-capsule.component';
import { SuperAdminComponent } from './admin/super-admin/super-admin.component';
import { SuperAdminCreateComponent } from './admin/super-admin-create/super-admin-create.component';
import { SuperAdminEditComponent } from './admin/super-admin-edit/super-admin-edit.component';
import { AdminForgotPasswordComponent } from './admin/admin-forgot-password/admin-forgot-password.component';
import { LogOutComponent } from './admin/log-out/log-out.component';
import { SettingComponent } from './admin/setting/setting.component';
import { ReportsComponent } from './admin/reports/reports.component';
import { PreventCopyPasteDirective } from './directive/prevent-copy-paste.directive';
import { ChangepasswordAdminComponent } from './admin/changepassword-admin/changepassword-admin.component';
import { PrivacyComponent } from './auth/privacy/privacy.component';
import { TermsComponent } from './auth/terms/terms.component';
import { CourseAssessmentViewComponent } from './admin/course-assessment-view/course-assessment-view.component';
import { UserContactUsComponent } from './layout/user-contact-us/user-contact-us.component';
import {ConnectionServiceModule} from 'ng-connection-service'; 
import { ManageTicketsComponent } from './admin/manage-tickets/manage-tickets.component';
import { TicketDetailComponent } from './admin/ticket-detail/ticket-detail.component';
import { AssessmentsComponent } from './layout/assessments/assessments.component';
import { CourseLibraryComponent } from './layout/course-library/course-library.component';
import { ManageAssessmentsComponent } from './admin/manage-assessments/manage-assessments.component';
import { CreateAssessmentComponent } from './admin/create-assessment/create-assessment.component';
import { ViewAssessmentComponent } from './admin/view-assessment/view-assessment.component';
import { AssessmentAssignUsersComponent } from './admin/assessment-assign-users/assessment-assign-users.component';
import { AssessmentViewUserComponent } from './admin/assessment-view-user/assessment-view-user.component';
import { ViewerAssessmentComponent } from './layout/viewer-assessment/viewer-assessment.component';
import { WordCountTooltipPipe } from './pipe/word-count-tooltip.pipe';
//import { ScrollToBottomDirective } from '././services/scroll-to-bottom.directive';
 
@NgModule({
  declarations: [
    AppComponent,
    WordCountTooltipPipe,
    AuthComponent,
    LoginComponent,
    AdminLoginComponent,
    LayoutComponent,
    AssignedComponent,
    HeaderComponent,
    FooterComponent,
    AssignedDetailsComponent,
    CompletedComponent,
    CompletedDetailsComponent,
    ViewerComponent,
    ViewerQuestionComponent,
    SubmodulePassedComponent,
    ModulePassedComponent,
    ModuleFailedComponent,
    ContactAdminComponent,
    AdminComponent,
    UserComponent,
    UserEditComponent,
    UserCreateComponent,
    HeaderAdminComponent,
    FooterAdminComponent,
    ViewerDetailsComponent,
    UserSuccessfullyComponent,
    ViewCoursesComponent,
    AssignCoursesComponent,
    UserDeactiveComponent,
    OrganisationComponent,
    OrganisationCreateComponent,
    CourseComponent,
    CourseDetailsComponent,
    OrganisationCourseComponent,
    CourseViewUserComponent,
    CourseViewCourseComponent,
    CourseCreateComponent,
    AssignedResumeComponent,
    CourseAddModulesComponent,
    CourseAddReviewComponent,
    CourseAddAssignUserComponent,
    CourseContentCapsuleComponent,
    ViewerQuestionLastComponent,
    AssignedDetailsMoudleComponent,
    CoursePublishComponent,
    AddModuleAssessmentComponent,
    AssignedAttemptComponent,
    AssignedDetailsResumeComponent,
    AssignedContactAdministratorComponent,
    AssignedResetRequestComponent,
    ChangepasswordComponent,
    AuthoringCreateComponent,
    AuthoringViewComponent,
    AuthoringAssessmentViewComponent,
    AuthoringListComponent,
    AuthoringActivatedCourseComponent,
    AuthoringDeactivatedCourseComponent,
    AuthoringViewContentComponent,
    ResetComponent,
    ResetRequestComponent,
    ContentAuthSuccessComponent,
    AddAuthoringAssessmentComponent,
    CourseAssignAfterPublishComponent,
    CoursesAssignUsersComponent,
    ForgetPasswordComponent,
    CreatePasswordComponent,
    ContactUsComponent,
    OrganizationSuccessfullyComponent,
    ViewCapsuleComponent,
    SuperAdminComponent,
    SuperAdminCreateComponent,
    SuperAdminEditComponent,
    AdminForgotPasswordComponent,
    LogOutComponent,
    SettingComponent,
    ReportsComponent,
    PreventCopyPasteDirective,
    ChangepasswordAdminComponent,
    PrivacyComponent,
    TermsComponent,
    CourseAssessmentViewComponent,
    UserContactUsComponent,
    ManageTicketsComponent,
    TicketDetailComponent,
    AssessmentsComponent,
    CourseLibraryComponent,
    ManageAssessmentsComponent,
    CreateAssessmentComponent,
    ViewAssessmentComponent,
    AssessmentAssignUsersComponent,
    AssessmentViewUserComponent,
    ViewerAssessmentComponent,
   // ScrollToBottomDirective,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    AppRoutingModule,
    MatInputModule,
    NgbModule,
    BrowserAnimationsModule,
    MatTabsModule,
    MatExpansionModule,
    MatTooltipModule,
    MatTableModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatSelectModule,
    MatCheckboxModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgbPaginationModule,
    NgbAlertModule,
    DragDropModule,
    HttpClientModule,
    NgxSpinnerModule,
    CKEditorModule,
    MatSortModule,
    MatStepperModule,
    CountdownModule,
    MatMenuModule,
    CdkStepperModule,
    ConnectionServiceModule,
    ToastrModule.forRoot()
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [ContentAuthoringService,{provide: LocationStrategy, useClass: HashLocationStrategy}],
  //providers: [ContentAuthoringService],
  bootstrap: [AppComponent]
})
export class AppModule { }
